import { render, staticRenderFns } from "./group_fast_mobile.vue?vue&type=template&id=581d927d&"
import script from "./group_fast_mobile.vue?vue&type=script&lang=js&"
export * from "./group_fast_mobile.vue?vue&type=script&lang=js&"
import style0 from "./group_fast_mobile.vue?vue&type=style&index=0&id=581d927d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports